import { render, staticRenderFns } from "./intellidataDevice.vue?vue&type=template&id=4c404e5a&scoped=true"
import script from "./intellidataDevice.vue?vue&type=script&lang=js"
export * from "./intellidataDevice.vue?vue&type=script&lang=js"
import style0 from "./intellidataDevice.vue?vue&type=style&index=0&id=4c404e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c404e5a",
  null
  
)

export default component.exports